import React from "react";
import { Route } from "react-router-dom";
import ReceiptModal from "../../Modal/ReceiptModal";

export function ReportAbuseReceiptModal({
  handleConfirmHide,
  isConfirmModal,
  data,
}) {
  console.log(data);
  return (
    <ReceiptModal
      handleConfirmHide={handleConfirmHide}
      isConfirmModal={isConfirmModal}
      title={`View Reported Details - ${data.id}`}
      row1col1Key={"Transaction ID"}
      row1col1Value={"T0B248932"}
      row1col2Key={"Sender Name	"}
      row1col2Value={"Henry Law"}
      row1col3Key={"Receiver Name"}
      row1col3Value={"Larry Law"}
      row2col1Key={"Amounts"}
      row2col1Value={"$1000"}
      row2col2Key={"Date"}
      row2col2Value={"Mon 02 Aug 2021 11:31:52 AM"}
      row2col3Key={"Confirmation ID"}
      row2col3Value={"02145566881"}
      row3col1Key={"Confirmation Date"}
      row3col1Value={"Mon 02 Aug 2021 11:31:52 AM"}
      row3col2Key={"SC Transaction ID"}
      row3col2Value={"SC79786854"}
      row3col3Key={"Deposite Type"}
      row3col3Value={"eCheck"}
      row4col1Key={"Status"}
      row4col1Value={"SUCCESS"}
      row4col2Key={"IP"}
      row4col2Value={"192.168.255.255"}
    />
  );
}
